// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__1-pkv","meta":"SideDrawer_meta__Lk-mT","red":"SideDrawer_red__3vu7l","spacer":"SideDrawer_spacer__wLn9M"};